import { useLocation, useParams } from "react-router";
import { Button, Form } from "react-bootstrap";

import {
  emptyString,
  BUTTON_TEXT,
  questionTypeConstants,
  surveyQuestionsConstants,
  archivedQuestionsConstants,
  STYLES,
} from "../../../constants";
import {
  handleSpace,
  archiveQuestionConfirmationModal,
  onKeyDownHandler,
} from "../../../../../shared";
import ArchiveButton from "../shared/archiveButton";
import useModalDisplay from "../../../../../shared/components/hooks/useModalDisplay/useModalDisplay";

const { STAR_RANKING } = questionTypeConstants;

const StarRanking = (props) => {
  const {
    index,
    errors,
    handle,
    register,
    question,
    localRole,
    questionList,
    setIsChanges,
    setQuestionList,
    handleSurveySubmit,
    handleRemoveQuestion,
    handleRecipientsUser,
    confirmReactivateArchiveQuestion,
  } = props;

  const { id, isNew, questionText, questionOrder } = question;

  const { brandId } = useParams();
  const location = useLocation();

  const isArchivedPage = location.pathname.includes(
    archivedQuestionsConstants.ARCHIVED_QUESTIONS
  );

  const isDisabled = localRole || question.isReadOnly || isArchivedPage;
  const isArchiveDisabled = localRole || !question.isReadOnly;

  const [showModal, modalElement, setComponent, closeModal] = useModalDisplay();

  //Function to handle input field
  const handleStarRankingQuestion = (value) => {
    const questionArray = questionList.map((obj) => {
      if (obj.questionOrder === questionOrder) {
        return {
          ...obj,
          questionText: value,
          isEdit: !isNew,
        };
      }
      return obj;
    });
    const updatedArray = handleRecipientsUser(questionArray);
    setQuestionList(updatedArray);
  };

  const handleQuestionRemove = () => {
    setIsChanges(true);
    handleRemoveQuestion(questionOrder, `${question.guid}`, id);
  };

  //If user confirm then check validation and save survey
  const archiveQuestionAndSaveSurvey = () => {
    const updatedQuestionArrayWithIsEdit = questionList.map((ques) => {
      return {
        ...ques,
        ...(Number(ques.questionOrder) > Number(questionOrder) && {
          isEdit: !ques.isNew,
        }),
      };
    });

    //Remove archived question and reorder
    const questionArrayWithOutArchivedQues = updatedQuestionArrayWithIsEdit
      .filter((q) => q.id !== question.id)
      .map((ques, index) => {
        return {
          ...ques,
          questionOrder: index + 1,
        };
      });
    handleSurveySubmit(questionArrayWithOutArchivedQues, question.id);
  };

  //Show confirmation modal when user click on archive modal
  const confirmArchiveQuestion = () => {
    setComponent(
      archiveQuestionConfirmationModal({
        onClose: closeModal,
        onConfirm: archiveQuestionAndSaveSurvey,
        message:
          "Would you like to archive this question? Archived questions can be reactivated for later use",
      })
    );
  };

  return (
    <>
      {/*Modal here */}
      {showModal && modalElement}
      <div
        className="notification-form shadow card mt-3"
        data-testid="survey-questions"
      >
        <div className="d-flex justify-content-between" {...handle}>
          <div
            role="button"
            tabIndex={0}
            data-testid="remove-survey-question"
            className={`remove-button ms-1 fs-6 fw-bold ${
              isDisabled ||
              questionOrder === 1 ||
              questionText === surveyQuestionsConstants.NPS_QUESTION
                ? "d-none"
                : emptyString
            }`}
            onClick={handleQuestionRemove}
            onKeyDown={(e) => {
              onKeyDownHandler(e, () => {
                handleQuestionRemove();
              });
            }}
          >
            ✖
          </div>
          <div className="d-flex align-items-center ms-auto">
            <ArchiveButton
              index={question.guid}
              questionText={questionText}
              onClick={confirmArchiveQuestion}
              isDisabled={isArchiveDisabled || isArchivedPage}
            />
            <div className="question-label ms-auto align-self-start">
              {STAR_RANKING}
            </div>
          </div>
        </div>
        <div className="card-body main-question-div  px-4 pt-0">
          <h5>Question {index}:</h5>
          <Form.Control
            type="text"
            name={`${question.guid}`}
            id={`${question.guid}`}
            data-testid="question-input"
            placeholder="How was your online ordering experience?"
            onKeyDown={(e) => handleSpace(e)}
            value={questionText || emptyString}
            {...register(`${question.guid}`, {
              required: !isDisabled,
              onChange: (e) => {
                handleStarRankingQuestion(e.target.value);
                setIsChanges(true);
              },
              disabled:
                questionText === surveyQuestionsConstants.NPS_QUESTION ||
                isDisabled,
            })}
            className={`${
              errors[`${question.guid}`] ? STYLES.IS_INVALID : emptyString
            }`}
          />
        </div>
        {isArchivedPage && (
          <div className="d-flex align-items-center px-4 pb-2 justify-content-end">
            <Button
              className="border-0 px-4 green-background-color"
              onClick={() =>
                confirmReactivateArchiveQuestion(brandId, question.id)
              }
            >
              {BUTTON_TEXT.REACTIVATE}
            </Button>
          </div>
        )}
      </div>
    </>
  );
};
export default StarRanking;
